import BaseFieldsDrawer from "./BaseFieldsDrawer"
import $ from "jquery"
import {ValidationErrors} from '../../panels/user/constants'
import {isEnterPressed, isEscapePressed} from '../../atBrowserUtils'

export default function PasswordFieldsDrawer(){}

PasswordFieldsDrawer.prototype = new BaseFieldsDrawer();

PasswordFieldsDrawer.prototype.init = function(config) {
    BaseFieldsDrawer.prototype.init.call(this, config)
    this.passwordsAreMandatory = config.passwordsAreMandatory
    this.disableValidation = config.disableValidation //todo[grishin]: for now it always true, as far as i see, so validation inside this class could be removed
    return this
}

PasswordFieldsDrawer.prototype.initFields = function(accountSettings){
    this.passwordField = $(this.getElementByIdFunction("passwordField"));
    this.passwordCopyField = $(this.getElementByIdFunction("passwordCopyField"));
    var self = this;
    this.passChangedHandler = function()
    {
        this.keyPressed = false;
        if (this.value.length > 0) self.changeDetectedFunction( true );
    };
    this.focusHandler = function()
    {
        this.inFocus = true;
    };

    this.passwordBlurHandlerGenerator = ({isPasswordChanged = false, isPasswordCopyChanged = false}) => function()
    {
        this.inFocus = false;
        $(this).pVal( this.value );
        //see Bug 48539
        if ( this.keyPressed )
        {
            self.passChangedHandler.call(this);
            self.changeDetectedFunction();
        }

        if (!self.disableValidation) {
            self._checkPasswordsMatch();
        }
        self.passwordField.trigger(
            "changed", [self.getPlainPasswordValues().password, self.getPlainPasswordValues().passwordCopy, isPasswordChanged, isPasswordCopyChanged])
        self.validationDetectedCallback()
        self.updateUICallback()
    };
};

PasswordFieldsDrawer.prototype.setPasswordsAreMandatory = function( passwordsAreMandatory )
{
    this.passwordsAreMandatory = passwordsAreMandatory;
};

PasswordFieldsDrawer.prototype.hasErrors = function() {
    return this.errors[ValidationErrors.PASSWORD_EMPTY] ||
           this.errors[ValidationErrors.PASSWORD_COPY_EMPTY] ||
           this.errors[ValidationErrors.PASSWORDS_DO_NOT_MATCH] ||
           this.errors[ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]
}

PasswordFieldsDrawer.prototype.setError = function(error) {
    for (let err of [ValidationErrors.PASSWORD_EMPTY,
                     ValidationErrors.PASSWORD_COPY_EMPTY,
                     ValidationErrors.PASSWORDS_DO_NOT_MATCH,
                     ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]) {
        this.errors[err] = err === error;
    }
}

PasswordFieldsDrawer.prototype._checkPasswordsMatch = function()
{
    var pswEmpty = this.passwordField.pVal().length == 0;
    var pswCopyEmpty = this.passwordCopyField.pVal().length == 0;


    this.errors[ValidationErrors.PASSWORD_EMPTY] = this.passwordsAreMandatory ? pswEmpty : false;
    this.errors[ValidationErrors.PASSWORD_COPY_EMPTY] = this.passwordsAreMandatory ? (!pswEmpty && pswCopyEmpty ): false;

    return (this.errors[ValidationErrors.PASSWORDS_DO_NOT_MATCH] =
            ( this.passwordsAreMandatory && !pswEmpty && !pswCopyEmpty || !this.passwordsAreMandatory ) &&
            this.passwordField.pVal() != this.passwordCopyField.pVal());
};

PasswordFieldsDrawer.prototype.setPasswordFieldsPlaceholders = function( pwdPlaceholder, pwdCopyPlaceholder )
{
    this.passwordField.off();
    this.passwordCopyField.off();

    this.setValue(this.passwordField, "")
    this.setValue(this.passwordCopyField, "")

    if (pwdPlaceholder)
        this.passwordField.attr("placeholder", pwdPlaceholder);

    if (pwdCopyPlaceholder)
        this.passwordCopyField.attr("placeholder", pwdCopyPlaceholder);

    this.passwordField.placeholder();
    this.passwordCopyField.placeholder();

    const handleKeyDown = function(e) {
        if (isEscapePressed(e) || isEnterPressed(e)) {
            this.blur()
            e.stopPropagation()
        }
    }

    this.passwordField.keydown(handleKeyDown);
    this.passwordCopyField.keydown(handleKeyDown);
    this.passwordField.keyup(this.passChangedHandler);
    this.passwordCopyField.keyup(this.passChangedHandler);
    this.passwordCopyField.focus(this.focusHandler);
    this.passwordField.blur(this.passwordBlurHandlerGenerator({isPasswordChanged: true}));
    this.passwordCopyField.blur(this.passwordBlurHandlerGenerator({isPasswordCopyChanged: true}));
};

PasswordFieldsDrawer.prototype.getNewPassword = function()
{
    if(!this.passwordField) return null;
    var passwordValue = this.passwordField.pVal();
    if(passwordValue.length > 0)
        return passwordValue;
    return null;
};

PasswordFieldsDrawer.prototype.validateFields = function(){
    this._checkPasswordsMatch();
    return this.errors;
};

PasswordFieldsDrawer.prototype.getObjectValues = function()
{
    return {newPassword : this.getNewPassword()};
};

PasswordFieldsDrawer.prototype.getPlainPasswordValues = function()
{
    return {
        password: this.passwordField.pVal(),
        passwordCopy: this.passwordCopyField.pVal()
    };
};

PasswordFieldsDrawer.prototype.getNotCopyValues = function(){
    return {passwordData : this.getPlainPasswordValues()} ;
};



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/PasswordFieldsDrawer.js